import * as React from "react"
import { Check } from "lucide-react"
import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  const handleClick = () => {
    if (!disabled && onCheckedChange) {
      onCheckedChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      data-state={checked ? "checked" : "unchecked"}
      ref={ref}
      onClick={handleClick}
      disabled={disabled}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-gray-300 bg-white",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00C2C2] focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "transition-colors duration-150",
        checked && "bg-[#00C2C2] border-[#00C2C2]",
        className
      )}
      {...props}
    >
      {checked && (
        <Check className="h-4 w-4 text-white" strokeWidth={3} />
      )}
    </button>
  );
});

Checkbox.displayName = "Checkbox"

export { Checkbox }